import { createSelector } from 'reselect';
import { IPermissions } from '../../models/auth';
import { IAppState } from '../reducers';

const hasPermission = (
  permissions: { [permissionName: string]: boolean },
  permission: string
) => permissions[permission] == true;

const getAllPermissions = (state: IAppState): IPermissions => {
  let auth = state.auth;

  let permissionsList: { [permissionName: string]: boolean } = {};
  let permissions: IPermissions = {
    hasPermission: (permission: string) =>
      hasPermission(permissionsList, permission),
    hasOneOfPermissions: (permissions: string[]) =>
      permissions.reduce(
        (prev, cur) => prev || hasPermission(permissionsList, cur),
        false
      ),
    hasAllPermissions: (permissions: string[]) =>
      permissions.reduce(
        (prev, cur) => prev && hasPermission(permissionsList, cur),
        true
      )
  };

  if (auth.facilityUser == null) {
    return permissions;
  }

  permissionsList = auth.facilityUser.roles
    .map((r) => {
      let permissions = r.permissions;
      // Remove any "false" permissions to avoid them potentially overwriting roles with "true" permissions
      for (const k in permissions) {
        if (permissions[k] == false) {
          delete permissions[k];
        }
      }
      return permissions;
    })
    .reduce((prev, cur) => Object.assign({}, prev, cur), {});

  // Temporary hack until everything is converted to React
  (window as any).permissions = permissions;

  return permissions;
};

export const getPermissions = createSelector(
  [getAllPermissions],
  (allPermissions) => allPermissions
);
